import { useEffect, useState } from 'react';

interface LoadingProgress {
  assets: number;
  components: number;
  total: number;
}

export const useAssetLoader = () => {
  const [progress, setProgress] = useState<LoadingProgress>({
    assets: 0,
    components: 0,
    total: 0
  });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadAssets = async () => {
      const assets = [
        // 3D Models
        '/human-body.glb',
        
        // Logo files
        '/Cinquity Logo Colored.png',
        '/Cinquity Logo Solid.png',
        '/Cinquity Logo White.png',
        
        // Platform mockups
        '/Cinquity Website Mockups/screen-template-1.png',
        '/Cinquity Website Mockups/screen-template-2.png',
        '/Cinquity Website Mockups/screen-template-3.png',
        '/Cinquity Website Mockups/screen-template-4.png',
        '/Cinquity Website Mockups/screen-template-5.png',
        '/Cinquity Website Mockups/screen-template-6.png',
        '/Cinquity Website Mockups/screen-template-7.png',
        '/Cinquity Website Mockups/cinquity-ai-studio-1.png',
        '/Cinquity Website Mockups/cinquity-ai-studio-2.png',
        '/Cinquity Website Mockups/cinquity-ai-studio-3.png',
        '/Cinquity Website Mockups/cinquity-ai-studio-4.png',
        '/Cinquity Website Mockups/cinquity-localization-1.png',
        '/Cinquity Website Mockups/cinquity-localization-2.png',
        '/Cinquity Website Mockups/cinquity-localization-3.png',
        '/Cinquity Website Mockups/cinquity-localization-4.png',
        '/Cinquity Website Mockups/cinquity-smart-data-dashboard-1.png',
        '/Cinquity Website Mockups/cinquity-smart-data-dashboard-2.png',
        '/Cinquity Website Mockups/cinquity-smart-data-dashboard-3.png',
        '/Cinquity Website Mockups/cinquity-byod-1.png',
        '/Cinquity Website Mockups/cinquity-byod-2.png',
        
        // Medical images
        '/crop-unrecognizable-worker-with-tablet-1024x683.webp',
        '/medical-banner-with-doctor-wearing-glove-1024x639.webp',
        '/medical-banner-with-doctor-wearing-goggles-scaled.webp',
        '/Untitled-design-2-1024x1024.webp',
      ];

      let loadedCount = 0;
      const totalAssets = assets.length;

      const loadAsset = (src: string): Promise<void> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            loadedCount++;
            setProgress(prev => ({
              ...prev,
              assets: Math.round((loadedCount / totalAssets) * 100),
              total: Math.round(((loadedCount + prev.components) / (totalAssets + 100)) * 100)
            }));
            resolve();
          };
          img.onerror = () => {
            loadedCount++;
            setProgress(prev => ({
              ...prev,
              assets: Math.round((loadedCount / totalAssets) * 100),
              total: Math.round(((loadedCount + prev.components) / (totalAssets + 100)) * 100)
            }));
            resolve(); // Continue even if some assets fail
          };
          img.src = src;
        });
      };

      // Load all assets
      await Promise.all(assets.map(loadAsset));

      // Mark components as loaded (no artificial delay)
      setProgress(prev => ({
        ...prev,
        components: 100,
        total: 100
      }));

      // Mark as loaded immediately when assets are ready
      setIsLoaded(true);
    };

    loadAssets();
  }, []);

  return { progress, isLoaded };
};
